export default __webpack_public_path__ + "static/media/SherlockOriginal.c573ba0a.jpeg";